

<div class="cursor-pointer w-72 bg-gradient-to-r from-gray-50 via-gray-100 to-gray-100 rounded animated fadeIn p-2 m-6 flex flex-col justify-center items-center hover:shadow-lg">
    <div class="bg-white cursor-pointer">
      <a target="_blank" (click)="seeArtists(artist)"><img [src]="artist.images | noimage" class="h-72 object-contain"></a>
    </div>
    <div class="text-gray-700 flex flex-col justify-center items-center">
      <span class="font-bold text-lg">{{artist.name}}</span>
      <p class="text-sm"><b>{{artist.followers?.total | numbeautify:2}}</b> followers</p>
    </div>
  </div>
